import RentalPortalListingProfile from '../RentalPortalListingProfile'

import * as styles from './RentalPortalListingProfilePreview.module.css'

function RentalPortalListingProfilePreview({
  activeItem,
  className = styles.RentalPortalListingProfilePreview,
  onClose,
}) {
  return (
    <RentalPortalListingProfile
      isPreview
      layoutProps={{ className }}
      listingId={activeItem}
      onClosePreview={onClose}
    />
  )
}

export default RentalPortalListingProfilePreview
